export enum Features {
  Redirect = 'disability_release_survey-pages-redirect',
  PageConsolidation = 'supply_platform_disability_form_update',
}
